<template>
  <div class="search-result-image">
    <SearchNohit v-if="ss.state.result.hit == 0" :message="ss.state.result.message" />
    <template v-else>
      <nav class="item-search-result-nav" role="toolbar">
        <h2 class="jps-is-hidden">
          {{ lss('検索結果件数', 'Search Result Number') }}
        </h2>
        <p class="is-size-7-touch">
          {{ lst(dapLangGlobal.numFound, num(ss.state.result.hit)) }}
        </p>
      </nav>
      <div class="item-search-result-body" role="main" aria-live="assertive">
        <h2 class="jps-is-hidden">{{ lss('検索結果', 'Search Result') }}</h2>
        <UiItemSearchResultGrid :test="test" :ss="ss" :simple="true" />
        <SearchInfiniteLoading :ss="ss" />
      </div>
    </template>
  </div>
</template>

<script lang="ts" setup>
import { dapLangGlobal } from '#imports'

const { lss, lst, num } = useI18n()

interface Props {
  test?: boolean
  ss: SearchStore<Item>
}
const props = withDefaults(defineProps<Props>(), {
  test: false,
})
</script>

<style lang="scss" scoped></style>
